import * as TE from "fp-ts/lib/TaskEither.js";

export const right = TE.right;

export const left = TE.left;

export const map = (f) => (taskEither) => TE.map(f)(taskEither);

export const chain = (taskEither) => (f) => TE.chain(f)(taskEither);

export const mapLeft = (f) => (taskEither) => TE.mapLeft(f)(taskEither);

export const fold = (taskEither) => (onLeft) => (onRight) => TE.fold(onLeft, onRight)(taskEither);

export const tryCatch = (thunk) => (onError) => TE.tryCatch(thunk, onError);

export const fromIO = TE.fromIO;

export const fromOption = (onNone) => (option) => TE.fromOption(onNone)(option);

export const fromIoEither = TE.fromIOEither;

export const rightTask = TE.rightTask;

export const sequence = (tasks) => async () => {
  const values = [];
  for (const task of tasks) {
    const result = await task();
    if (result._tag === "Left") {
      return result;
    }
    values.push(result.right);
  }
  return { _tag: "Right", right: values };
};
